export const AUTO_LAYOUT_DIRECTION_RIGHT = 'RIGHT';
export const AUTO_LAYOUT_DIRECTION_LEFT = 'LEFT';
export const AUTO_LAYOUT_DIRECTION_DOWN = 'DOWN';
export const AUTO_LAYOUT_DIRECTION_UP = 'UP';

export const AUTO_LAYOUT_DEFAULT_DIRECTION = AUTO_LAYOUT_DIRECTION_DOWN;

export const CUSTOM_EVENT_AUTO_LAYOUT = 'publishpress_future_workflow_editor_auto_layout';
